document.addEventListener('DOMContentLoaded', function () {
	const formId = 28;

	// Map each checkbox to its hidden field + message
	const checkboxConfig = {
		choice_28_3_1: {
			targetId: 'input_28_8',
			message:
				"We can cover up to $5000 for therapy with your chosen therapist. Please share their contact info and your consent using this form so we can set up direct billing: <strong>https://wpo.qualtrics.com/jfe/form/SV_29QpglgXTfx3fgy</strong>",
		},
		choice_28_3_2: {
			targetId: 'input_28_9',
			message:
				"We can cover up to $3000 for your lawyer. Please give us their contact info and your consent using this form so we can arrange direct billing: <strong>https://wpo.qualtrics.com/jfe/form/SV_29QpglgXTfx3fgy</strong>",
		},
		choice_28_3_3: {
			targetId: 'input_28_10',
			message:
				"You can request help with costs related to your harassment experience. Upload documents and explain how this support will help you move forward: <strong>https://wpo.qualtrics.com/jfe/form/SV_8wtCDq4PvVTxNOK</strong>",
		},
		choice_28_3_4: {
			targetId: 'input_28_11',
			message:
				"You may benefit from services from our partner WPO, including career coaching and financial advice. To access these services, please call: <strong>1-833-622-7404</strong>",
		},
	};

	function updateHiddenFields() {
		for (const [checkboxId, config] of Object.entries(checkboxConfig)) {
			const checkbox = document.getElementById(checkboxId);
			const target = document.getElementById(config.targetId);

			if (!checkbox || !target) {
				continue;
			}

			if (checkbox.checked) {
				target.value = config.message;
				console.log(
					`Set message for ${checkboxId} into #${config.targetId}`
				);
			} else {
				target.value = '';
				console.log(
					`Cleared message for ${checkboxId} from #${config.targetId}`
				);
			}
		}
	}

	// Attach change listeners to each checkbox
	for (const checkboxId of Object.keys(checkboxConfig)) {
		const checkbox = document.getElementById(checkboxId);
		if (!checkbox) {
			continue;
		}

		checkbox.addEventListener('change', function () {
			updateHiddenFields();
		});
	}

	// Initialize once on load (handles pre-checked states)
	updateHiddenFields();
});
